import {Component} from '@angular/core';

@Component({
  selector: 'app-blog',
  templateUrl: './blog.component.html',
  styleUrls: ['./blog.component.scss']
})
export class BlogComponent {

  constructor() {
  }

  // Blog Carousel
  public blog = [{
    image: 'assets/images/home/special_1.png',
    date: '15 jun 2016',
    title: '九宫格火锅 Nine trellis Hot Pot',
    postedBy: '适合与亲友分享的经典火锅 | A classic Hot Pot for sharing',
  }, {
    image: 'assets/images/home/special_2.png',
    date: '10 February 2012',
    title: '麻辣牛肉 Saute beef with cayenne pepper',
    postedBy: '蜀香格秘制特色 | House-made special with our own recipe',
  }, {
    image: 'assets/images/home/special_3.png',
    date: '12 march 2015',
    title: '炸酥肉 Fired crispy pork',
    postedBy: '香脆酥软，解馋解腻 | A perfect match with Sichuan Hot Pot',
  }, {
    image: 'assets/images/home/special_4.png',
    date: '28 December 2017',
    title: '虾滑 Mashed shrimp',
    postedBy: '浓郁虾味，细腻爽滑 | Rich seafood flavour that tastes smooth and tender',
  }];


  // Blog Carousel Options
  public blogCarousel: any = {
    loop: true,
    margin: 30,
    nav: false,
    dots: true,
    responsive: {
      0: {
        items: 1,
        margin: 5,
        nav: false,
      },
      600: {
        items: 1,
        margin: 0,
        nav: false,
      },
      768: {
        items: 2,
      },
      1000: {
        items: 2
      }
    }
  };

}
